module.exports = __webpack_public_path__ + "static/img/Ellipse65.5a696883.png";